import { Route, Routes } from 'react-router-dom';

import CheckoutPage from './pages/CheckoutPage';

export default function App() {
  return (
    <Routes>
      <Route path="/c/:checkoutId" element={<CheckoutPage />} />
      <Route path="*" element={<div />} />
    </Routes>
  );
}
